export var PAGE_TERMS = {
  title: 'rubriq.plan-page-header',
  subtitle: 'rubriq.plan-page-header-description',
  monthly: 'curie.monthly',
  annual: 'rubriq.pricing.annual',
  popular: 'rubriq.most-popular',
  morePlans: 'rubriq.pricing.more-plans',
  freeTrial: 'curie.get-starter'
};
export var PERIOD_TERMS = {
  month: 'curie.month',
  year: 'curie.year'
};
export var ATOM_TERMS = {
  save: 'rubriq.save',
  off: 'rubriq.off'
};
export var PLAN_TERMS = {
  premium: {
    title: 'curie.curie-premium',
    pill: 'rubriq.premium-plan-description',
    featuresPrefix: 'rubriq.pricing.includes',
    buttonLabel: 'curie.upgrade-to-premium-title'
  },
  translation: {
    title: 'rubriq.rubriq-premium-with-translation',
    pill: 'rubriq.premium-with-translation-plan-description',
    featuresPrefix: 'rubriq.pricing.translation-includes',
    buttonLabel: 'rubriq.pricing.get-premium-with-translation'
  }
};
export var ROW_CTA_TERMS = {
  startTrial: 'rubriq.get-starter',
  subscribe: 'subscribe',
  startCardlessTrial: 'rubriq.start-free-trial-no-card',
  upgradeAndPay: 'rubriq.upgrade-and-pay-now'
};

/**
 * Shown instead of ROW_CTA_TERMS.startCardlessTrial until that term is translated, so an
 * untranslated locale shows English rather than the raw term name.
 */
export var CARDLESS_TRIAL_CTA_FALLBACK = 'Start free trial';
export var FEATURE_LIST_TERMS = {
  premium: 'rubriq.premium-editing-feature-list',
  translation: 'rubriq.premium-with-translation-feature-list',
  translationDeepseek: 'rubriq.premium-with-translation-feature-list-deepseek',
  group: 'curie.preferred-group-feature-list',
  plagiarism: 'plagiarism-feature-list'
};
export var GROUP_PLAN_TERMS = {
  title: 'rubriq.preferred-group',
  pill: 'rubriq.group-plan-description',
  price: 'curie.custom',
  featuresPrefix: 'rubriq.pricing.includes',
  buttonLabel: 'curie.contact-us'
};
export var PLAGIARISM_PLAN_TERMS = {
  title: 'plagiarism_check',
  poweredBy: 'powered_by',
  oneTime: 'rubriq.pricing.one-time',
  perDocument: 'iThenticate_per_document',
  buttonLabel: 'get_your_report_now'
};
export var GROUP_PLAN_URLS = {
  row: 'https://www.aje.com/group-discounts',
  china: 'https://www.aje.cn/group-discounts'
};
export var PLAGIARISM_PATH = '/rubriq/plagiarism';